import React from "react";

export default function TabButton({
  tabName,
  activeTab,
  onClick,
  glowColor,
  children
}) {
  const isActive = tabName === activeTab;
  return (
    <button
      onClick={() => onClick(tabName)}
      style={{ "--btn-glow": glowColor }}
      className={[
        "btn-dynamic px-3 sm:px-4 md:px-5 py-1.5 sm:py-2 rounded-full font-semibold transition-all duration-200 text-xs sm:text-sm md:text-base whitespace-nowrap",
        isActive
          ? "bg-transparent text-white border border-cyan-400/50 shadow-[0_0_15px_rgba(6,182,212,0.5),0_0_30px_rgba(139,92,246,0.3)]"
          : "bg-white bg-opacity-10 text-gray-400 hover:bg-opacity-20 hover:text-white"
      ].join(" ")}
    >
      {children}
    </button>
  );
}
